import { useEffect, useMemo, useRef, useState, useContext } from 'react';
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
import axios from '../../../axios';
import { Paper, Text, Button,Loader } from '@mantine/core';
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';
import { fy } from 'date-fns/locale';
// Format date function
const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

// Format percentage with fallback
const formatPercentage = (value) => (value == null || isNaN(parseFloat(value)) ? '--' : `${parseFloat(value).toFixed(2)}%`);

// Format text with fallback
const formatText = (value) => (value == null || value === '' ||value===undefined? '--' : value);

const Example = ({ batchPhase, batch, state, district, year, scheme, sector, jobRole, reportType, type, centre, start, end, generateClicked,tbn_no }) => {
  const [data, setData] = useState([]);
  const [batchData, setBatchData] = useState(null);
  const [total, setTotal] = useState({});
  const [loading, setLoading] = useState(false);
  const [errorOccurred, setErrorOccurred] = useState(false); // New state for error tracking
  const rowVirtualizerInstanceRef = useRef(null);

  const columns = [
    { accessorKey: 'financial_year', header: "Financial Year", Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'scheme_name', header: 'Scheme Name', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'training_type', header: 'STT/RPL', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'state', header: 'State', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'district', header: 'District', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'centre_name', header: 'Centre Name', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'vtp_id', header: 'TC ID', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'sector_name', header: 'Sector Name', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'job_role_name', header: 'Job Role Name', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'tbn_no', header: 'Batch ID', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'batch_name', header: 'Batch Name', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'start_date', header: 'Start Date', Cell: ({ cell }) => formatDate(cell.getValue()) },
    { accessorKey: 'end_date', header: 'End Date', Cell: ({ cell }) => formatDate(cell.getValue()) },
    { accessorKey: 'upsdm_id', header: 'Candidate ID', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'attendee_id', header: 'SIP ID', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'fullname', header: 'Name', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'gender', header: 'Gender', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'dob', header: 'DOB', Cell: ({ cell }) => formatDate(cell.getValue()) },
    { accessorKey: 'aadhar_no', header: 'Aadhar No.', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'qualification', header: 'Education Attained ', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'caste', header: 'Caste', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'religion', header: 'Religion', Cell: ({ cell }) => formatText(cell.getValue()) }, 
    { accessorKey: 'contact_no', header: 'Mobile No.', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'email', header: 'Email', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'mother_name', header: 'Mother Name', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'guardian_name', header: 'Guardian Name', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'permenent_address', header: 'Permanent Address', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'Student_City', header: 'City', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'Student_Destrict', header: 'District', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'bank_name', header: 'Bank Name', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'bank_acc_no', header: 'Account No.', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'ifsc_code', header: 'IFSC Code', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'branch', header: 'Branch Name', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'result_status', header: 'Result', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'is_placed', header: 'Placement Status', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'company', header: 'Company', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'company_address'  , header: 'Company Address', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'self_employed', header: 'Self Employed', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'employer_name', header: 'Employer Name', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'emp_contact_no', header: 'Employer Contact', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'emp_email', header: 'Employer Email', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'designation', header: 'Designation', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'position', header: 'Position', Cell: ({ cell }) => formatText(cell.getValue()) },
    {accessorKey: 'date_of_joining',header: 'Joining Date',Cell: ({ cell }) => {const value = cell.getValue(); return value == null || value === '' ? '---' : formatDate(value)}, },
    { accessorKey: 'salary_amount', header: 'Monthly Salary', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'first_salary_amount', header: '1st Month Salary', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'second_salary_amount', header: '2nd Month Salary', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'third_salary_amount', header: '3rd Month Salary', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'fourth_salary_amount', header: '4th Month Salary', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'fifth_salary_amount', header: '5th Month Salary', Cell: ({ cell }) => formatText(cell.getValue()) },
    { accessorKey: 'sixth_salary_amount', header: '6th Month Salary', Cell: ({ cell }) => formatText(cell.getValue()) },
  ];

  const fetchData = async () => {
    setLoading(true);
    try {
      
      setErrorOccurred(false); // Reset error state on new fetch attempt
      const response = await axios.post('/batch/summaryReport', {
        centre_id: centre,
        scheme_id: scheme,
        start_date: start,
        end_date: end,
        financial_year: year,
        sector_id: sector,
        job_role_name: jobRole,
        state,
        district,
        batch_type: batchPhase,
        tbn_no: batch,
         type:type,
      })
      const resData = response.data;
      //console.log(resData);
      if (resData.message) {
        toast.error(resData.message);
        // console.log(resData.message)
        setErrorOccurred(true); // Set error flag
      } else {
        setBatchData(resData.total_batch_count);
        setTotal(resData.total_students_count[0]);
        setData(resData[`${reportType}_students`] || resData.enrolled_students);
        //console.log(resData[`${reportType}_students`] )
      }
    } catch (err) {
      toast.error('Error fetching data');
      setErrorOccurred(true); // Set error flag
    } finally {
      setLoading(false);
    }
  };
  //console.log(total)

useEffect(()=>{
  fetchData();
},[generateClicked])
// Mapping for header names in the exported student file
// Function to format date for Excel
const formatDateForExcel = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-GB'); // Format as dd/mm/yyyy
};

const headerMapping = {
  sr_no: 'Sr. No.',
  financial_year: 'Financial Year',
  scheme_name: 'Scheme Name',
  rpl_type: 'STT/RPL',
  state: 'State',
  district: 'District',
  centre_name: 'Centre Name',
  vtp_id: 'TC ID',
  sector_name: 'Sector Name',
  job_role_name: 'Job Role Name',
  tbn_no: 'Batch ID',
  batch_name: 'Batch Name',
  start_date: 'Start Date',
  end_date: 'End Date',
  upsdm_id: 'Candidate ID',
  attendee_id: 'SIP ID',
  fullname: 'Name',
  gender: 'Gender',
  dob: 'DOB',
  aadhar_no: 'Aadhar No.',
  qualification: 'Education Attained',
  caste: 'Caste',
  religion: 'Religion',
  mobile_no: 'Mobile No.',
  email: 'Email',
  mother_name: 'Mother Name',
  guardian_name: 'Guardian Name',
  permenent_address: 'Permanent Address',
  Student_City: 'City',
  Student_Destrict: 'District',
  bank_name: 'Bank Name',
  account_no: 'Account No.',
  ifsc_code: 'IFSC Code',
  branch_name: 'Branch Name',
  result_status: 'Result',
  is_placed: 'Placement Status',
  company: 'Company',
  company_address: 'Company Address',
  self_employed: 'Self Employed',
  employer_name: 'Employer Name',
  emp_contact_no: 'Employer Contact',
  emp_email: 'Employer Email',
  designation: 'Designation',
  position: 'Position',
  date_of_joining: 'Joining Date',
  salary_amount: 'Monthly Salary',
  first_salary_amount: '1st Month Salary',
  second_salary_amount: '2nd Month Salary',
  third_salary_amount: '3rd Month Salary',
  fourth_salary_amount: '4th Month Salary',
  fifth_salary_amount: '5th Month Salary',
  sixth_salary_amount: '6th Month Salary',
};
// Function to export student data to Excel
const exportStudentDataToExcel = () => {
  const exportData = data.map((row ,index) => {
    return {
      sr_no: formatText(index+1),
      financial_year: formatText(row.financial_year),
      scheme_name: formatText(row.scheme_name),
      rpl_type: formatText(row.training_type),
      state: formatText(row.state),
      district: formatText(row.district),
      centre_name: formatText(row.centre_name),
      vtp_id: formatText(row.vtp_id),
      sector_name: formatText(row.sector_name),
      job_role_name: formatText(row.job_role_name),
      tbn_no: formatText(row.tbn_no),
      batch_name: formatText(row.batch_name),
      start_date: formatDateForExcel(row.start_date),
      end_date: formatDateForExcel(row.end_date),
      upsdm_id: formatText(row.upsdm_id),
      attendee_id: formatText(row.attendee_id),
      fullname: formatText(row.fullname),
      gender: formatText(row.gender),
      dob: formatDateForExcel(row.dob),
      aadhar_no: formatText(row.aadhar_no),
      qualification: formatText(row.qualification),
      mobile_no: formatText(row.contact_no),
      email: formatText(row.email),
      caste: formatText(row.caste),
      religion: formatText(row.religion),
      mother_name: formatText(row.mother_name),
      guardian_name: formatText(row.guardian_name),
      permenent_address: formatText(row.permenent_address),
      Student_City: formatText(row.Student_City),
      Student_Destrict: formatText(row.Student_Destrict),
      bank_name: formatText(row.bank_name),
      account_no: formatText(row.bank_acc_no),
      ifsc_code: formatText(row.ifsc_code),
      branch_name: formatText(row.branch),
      result_status: formatText(row.result_status),
      is_placed: formatText(row.is_placed),
      company: formatText(row.company),
      company_address: formatText(row.company_address),
      self_employed: formatText(row.self_employed),
      employer_name: formatText(row.employer_name),
      emp_contact_no: formatText(row.emp_contact_no),
      emp_email: formatText(row.emp_email),
      designation: formatText(row.designation),
      position: formatText(row.position),
      date_of_joining: formatDateForExcel(row.date_of_joining),
      salary_amount: formatText(row.salary_amount),
      first_salary_amount: formatText(row.first_salary_amount),
      second_salary_amount: formatText(row.second_salary_amount),
      third_salary_amount: formatText(row.third_salary_amount),
      fourth_salary_amount: formatText(row.fourth_salary_amount),
      fifth_salary_amount: formatText(row.fifth_salary_amount),
      sixth_salary_amount: formatText(row.sixth_salary_amount),
    };
  });

  const ws = XLSX.utils.json_to_sheet(exportData, { header: Object.keys(headerMapping) });
  // Change the header names in the worksheet
  ws['!cols'] = Object.keys(headerMapping).map(() => ({ wpx: 150 })); // Adjust column widths

  // Update header names in the worksheet
  const newHeaders = Object.values(headerMapping);
  newHeaders.forEach((header, index) => {
    ws[XLSX.utils.encode_cell({ r: 0, c: index })].v = header;
  });

  const wb = XLSX.utils.book_new(); // Create a new workbook
  XLSX.utils.book_append_sheet(wb, ws, 'Student Report'); // Append worksheet
  XLSX.writeFile(wb, 'Student_Report.xlsx'); // Save as Excel file
};




  const table = useMantineReactTable({
    data,
    columns,
    enableGlobalFilter: true,
    enableColumnFilterModes: true,
    enablePinning: true,
    enablePagination: true,
    enableMultiSort: true, 
    columnFilterDisplayMode:"popover",
    paginationDisplayMode:"pages",
    positionToolbarAlertBanner:"bottom",
    enableColumnResizing: true,
    enableColumnFilter: true,
    enableColumnSelection: true,
    enableGlobalFilter: true,
    enableGlobalFilterModes: true,
    enableStickyHeader: true,
    enableColumnSticky: true,
    enableRowNumbers: true,
    enableRowActions: true,
  });

  return (
    <>
      {loading ?<div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
  }}>
    <Loader variant="dots" color="indigo"   size={50} />
  </div>:(
        <> 
        <Paper shadow="sm" p="lg" withBorder className="bg-violet-50">

          <div className="flex justify-between mb-2">
            <Text weight={500} size="lg" className="text-sky-700">
              Students : {total.total_students}
            </Text>
            {!errorOccurred && total.total_students > 0 && (
  <Button
    onClick={exportStudentDataToExcel}
    color="green"
    size="md"
  >
    Export to Excel
  </Button>
)}

          </div>
          <div className="flex justify-between">
            <Text className="text-gray-600">Enrolled: {total.total_students}</Text>
            <Text className="text-green-600">Passed: {total.pass_students}</Text>
            <Text className="text-yellow-600">Placed: {total.placed_students}</Text>
            <Text className="text-blue-600">Assessed: {total.assessment_completed_batches}</Text>
            <Text className="text-rose-600">Failed: {total.fail_students}</Text>
          </div>
        </Paper>

      {!errorOccurred && (
        <Paper shadow="sm" p="lg" withBorder>
         
          <MantineReactTable
            table={table}
            enableColumnResizing={true}
            rowVirtualizerInstanceRef={rowVirtualizerInstanceRef}
            enablePagination={false}
            enableRowSelection={true}
            enableStickyHeader={true}
            initialState={{
              columnVisibility: {
                fullname: true,
                course_name: true,
              },
            }}
          />
        </Paper>
      )}</>)}
    </>
  );
};

export default Example;
